import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'src/components/translate';

const StoreCount = ({ name, prices }) => {
  const numberOfStores =
    prices &&
    prices.meta &&
    prices.meta.storeStatistics &&
    prices.meta.storeStatistics.totalCount
      ? Math.max(1, prices.meta.storeStatistics.totalCount)
      : 1;
  return name ? (
    <Translate domain="product" product={name} n={numberOfStores}>
      product-info.store-count
    </Translate>
  ) : null;
};

const { string, number, shape } = PropTypes;

StoreCount.propTypes = {
  name: string,
  prices: shape({
    meta: shape({
      storeStatistics: shape({
        totalCount: number,
      }),
    }),
  }),
};

StoreCount.defaultProps = {
  name: undefined,
  prices: undefined,
};

export default StoreCount;
